import { render, staticRenderFns } from "./Anylise.vue?vue&type=template&id=361339b5&scoped=true&"
import script from "./Anylise.vue?vue&type=script&lang=js&"
export * from "./Anylise.vue?vue&type=script&lang=js&"
import style0 from "./Anylise.vue?vue&type=style&index=0&id=361339b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361339b5",
  null
  
)

export default component.exports